import { render, staticRenderFns } from "./MQSeriesConfigurationForm.vue?vue&type=template&id=ddea03fc&"
import script from "./MQSeriesConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./MQSeriesConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddea03fc')) {
      api.createRecord('ddea03fc', component.options)
    } else {
      api.reload('ddea03fc', component.options)
    }
    module.hot.accept("./MQSeriesConfigurationForm.vue?vue&type=template&id=ddea03fc&", function () {
      api.rerender('ddea03fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/MQSeriesConfigurationForm.vue"
export default component.exports